export default "__VITE_ASSET__ZBwE0eR4__"